<template>
  <div class="activity-loading-container">
    <div :class="classContainerLoading">
      <div class="activity-loading__content">
        <div class="activity-loading__content-loading">
          <span :class="activityLoadingTitleClass">{{ textTitle }}</span>
          <progressbar
            :bg-color-progress="bgColorProgress"
            :bg-color-progress-bar="bgColorProgressBar"
            :value="percent"
          />
        </div>
      </div>
    </div>
    <activity-bumper
      v-if="enableBumper"
      :class="classContainerBumper"
      @on-completed="onBumperCompleted"
    ></activity-bumper>
  </div>
</template>

<script>
import { Progressbar } from '../../Progressbar';
import ActivityBumper from './ActivityBumper';

export default {
  name: 'ActivityLoading',
  components: {
    ActivityBumper,
    Progressbar,
  },
  data() {
    return {
      percent: 0,
      timePercent: null,
      isShowLoading: false,
      loadingCompleted: false,
    };
  },
  props: {
    percentValue: {
      type: [Number, String],
      default: 0,
    },
    textTitle: {
      type: String,
      default: 'Loading...',
    },
    textColorLoadingTitle: {
      type: String,
    },
    bgColorProgress: {
      type: String,
    },
    bgColorProgressBar: {
      type: String,
    },
    bgColorActivity: {
      type: String,
    },
    nextComponent: {
      type: String,
      required: true,
    },
    enableBumper: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    classContainerLoading() {
      const classes = {
        'activity-loading': true,
        'activity-slide': true,
      };

      classes[`bg-${this.bgColorActivity}`] = !!this.bgColorActivity;
      classes['activity-slide--transparent'] = !this.isShowLoading;

      return {
        ...classes,
      };
    },
    classContainerBumper() {
      const classes = {
        'activity-slide': true,
      };

      classes['activity-slide--transparent'] = this.isShowLoading;

      return {
        ...classes,
      };
    },
    activityLoadingTitleClass() {
      const classes = {
        'activity-loading__title': true,
      };

      classes[`text-${this.textColorLoadingTitle}`] =
        !!this.textColorLoadingTitle;

      return {
        ...classes,
      };
    },
  },
  methods: {
    onBumperCompleted() {
      this.isShowLoading = true;
    },
  },
  mounted() {
    this.isShowLoading = this.enableBumper ? this.isShowLoading : true;
  },
  watch: {
    loadingCompleted(newLoading) {
      if (newLoading) {
        this.onSwapComponent(this.nextComponent);
        this.$emit('onNextView', this.nextComponent);
      }
    },
    percent(newValue) {
      if (newValue && newValue === 100) {
        clearInterval(this.timePercent);
      }
    },
    isShowLoading(newShowLoading) {
      if (newShowLoading) {
        const timerIncrementLoading = () => {
          if (this.percent < 100) {
            this.percent += 0.5;
          } else {
            if (this.percent === this.percentValue) {
              setTimeout(() => {
                this.loadingCompleted = this.percent === this.percentValue;
              }, 1500);

              clearInterval(fauxProgress);
            }
          }
        };

        const fauxProgress = setInterval(timerIncrementLoading, 10);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../Styles/activity_loading.styl'

.activity-loading-container
  position relative
  height 100%

  .activity-slide
    position:absolute
    width 100%
    left:0
    transition: opacity 1s ease-in-out

    &--transparent
      opacity 0
</style>
